/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dropdailyredeemed2Inputs */

const en_dropdailyredeemed2 = /** @type {(inputs: Dropdailyredeemed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Redeemed`)
};

const de_dropdailyredeemed2 = /** @type {(inputs: Dropdailyredeemed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eingelöst`)
};

/**
* | output |
* | --- |
* | "Redeemed" |
*
* @param {Dropdailyredeemed2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const dropdailyredeemed2 = /** @type {((inputs?: Dropdailyredeemed2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dropdailyredeemed2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dropdailyredeemed2(inputs)
	return de_dropdailyredeemed2(inputs)
});
export { dropdailyredeemed2 as "dropDailyRedeemed" }